import BaseDrawer from '@/components/BaseDrawer';
import BaseDialog from "@/components/BaseDialog";

// 编辑传化出价
export function conversionDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./conversionDrawer'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '转化出价',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}

// 创意组
export function adSourceDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./adSource.vue'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '创意组',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.remove('f-hide');
      }
    }
  })
}


// 广告标题 添加文案adTitleDrawer
export function adTitleDrawer ({ props, cbs }) {
  const w = document.body.clientWidth;
  return new BaseDrawer({
    component: ()=>import('./adTitle.vue'),
    options: {
      size: w>=1200? '1200px': '100%',
      title: '广告标题',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs
  })
}

// 批量录入
export function batchEnterModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./batchEnterModal'),
    options: {
      width: '600px',
      title: '批量录入产品'
    },
    props,
    cbs
  })
}

// 添加转化名称
export function addConvNameModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./addConvNameModal'),
    options: {
      width: '500px',
      title: '添加转化名称'
    },
    props,
    cbs,
  })
}
// 提示
export function tipModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./tipModal'),
    options: {
      width: '500px',
      title: '提示',
      'lock-scroll': false
    },
    props,
    cbs,
    on: {
      closed() {
        const body = document.body;
        body.classList.add('f-hide');
      }
    }
  })
}

// 广告描述 推广产品名称 广告品牌描述
export function adsEditNameModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./adsEditName.vue'),
        options: {
            width: '600px',
            title: props.title || '提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 二次确认  去除特殊字符
export function doubleConfirmationModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./doubleConfirmation.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 生成预览 提交失败
export function submitErrorModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./submitError.vue'),
        options: {
            width: '600px',
            title: '提交失败',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}